// profile_of_referrals codes from the 2026-10-30 dictionary.
// Forms store dictionary IDs; these codes only identify the relevant options.
export const PROFILE_OF_REFERRAL_CODES = {
	familyMembersCarers: '20',
	selfApproach: '21',
	othersSpecify: '22h',
} as const;

interface ReferralOption {
	id: string;
	code?: string | number;
}

export const getProfileOfReferralId = (
	options: readonly ReferralOption[] | null | undefined,
	approachSource: string | number | null | undefined
): string => {
	let code: string;
	switch (approachSource) {
		case 0:
		case '0':
			code = PROFILE_OF_REFERRAL_CODES.familyMembersCarers;
			break;
		case 1:
		case '1':
			code = PROFILE_OF_REFERRAL_CODES.selfApproach;
			break;
		default:
			return '';
	}
	return options?.find((option) => String(option.code) === code)?.id ?? '';
};

export const isProfileOfReferralOthers = (
	options: readonly ReferralOption[] | null | undefined,
	id: string | null | undefined
): boolean => {
	if (!id) return false;
	return (
		options?.find((option) => option.id === id)?.code ===
		PROFILE_OF_REFERRAL_CODES.othersSpecify
	);
};